var _path, _path2, _path3, _path4, _path5, _circle, _circle2, _circle3, _path6, _path7, _path8, _circle4, _circle5, _circle6, _g, _g2, _g3, _g4, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIntensiveMinutes(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 292,
    height: 152,
    viewBox: "0 0 292 152",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M112 121C140.719 121 164 97.7188 164 69C164 40.2812 140.719 17 112 17C83.2812 17 60 40.2812 60 69C60 97.7188 83.2812 121 112 121Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M138 104C166.719 104 190 80.7188 190 52C190 23.2812 166.719 0 138 0C109.281 0 86 23.2812 86 52C86 80.7188 109.281 104 138 104Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M129 145C157.719 145 181 121.719 181 93C181 64.2812 157.719 41 129 41C100.281 41 77 64.2812 77 93C77 121.719 100.281 145 129 145Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M164 152C192.719 152 216 128.719 216 100C216 71.2812 192.719 48 164 48C135.281 48 112 71.2812 112 100C112 128.719 135.281 152 164 152Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M173 121C201.719 121 225 97.7188 225 69C225 40.2812 201.719 17 173 17C144.281 17 121 40.2812 121 69C121 97.7188 144.281 121 173 121Z",
    fill: "white"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 263,
    cy: 67,
    r: 3,
    fill: "white"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 24,
    cy: 142,
    r: 3,
    fill: "white"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 290,
    cy: 118,
    r: 2,
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M241.5 32.5L261.5 28",
    stroke: "white",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M257 128.5L268.5 132.5",
    stroke: "white",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M6.5 34L23 37.5",
    stroke: "white",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 253.5,
    cy: 1.5,
    r: 1.5,
    fill: "white"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 15.5,
    cy: 79.5,
    r: 1.5,
    fill: "white"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 1.5,
    cy: 6.5,
    r: 1.5,
    fill: "white"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_11304_9690)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M145 124C173.719 124 197 100.719 197 72C197 43.2812 173.719 20 145 20C116.281 20 93 43.2812 93 72C93 100.719 116.281 124 145 124Z",
    fill: "#C9203D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.337 51.5827C149.785 52.3803 147.393 53.9754 145.319 55.8895C143.086 53.9754 140.853 52.3803 138.301 51.5827C128.89 48.7116 120.914 57.6441 120.914 66.4171C120.914 83.0061 141.81 99.7545 145.319 99.7545C148.828 99.7545 169.724 83.1656 169.724 66.4171C169.724 57.6441 161.429 48.7116 152.337 51.5827Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_11304_9690)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M228.606 119.952C239.625 120.722 249.182 112.415 249.953 101.396C250.723 90.377 242.415 80.8199 231.397 80.0494C220.378 79.2789 210.821 87.5868 210.05 98.6056C209.28 109.624 217.588 119.181 228.606 119.952Z",
    fill: "#C9203D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M233.365 92.3676C232.364 92.6052 231.404 93.153 230.557 93.8317C229.751 93.0374 228.937 92.3655 227.979 91.991C224.446 90.6369 221.146 93.8502 220.911 97.2162C220.465 103.581 228.033 110.568 229.38 110.662C230.726 110.756 239.188 104.952 239.638 98.5257C239.873 95.1597 236.93 91.51 233.365 92.3676Z",
    fill: "white"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip2_11304_9690)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M65.7431 44.9211C76.7468 43.9584 84.8866 34.2577 83.9239 23.2541C82.9612 12.2504 73.2606 4.1106 62.2569 5.07329C51.2532 6.03599 43.1134 15.7366 44.0761 26.7403C45.0388 37.744 54.7395 45.8838 65.7431 44.9211Z",
    fill: "#C9203D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.1276 16.9318C65.1765 17.323 64.3132 18.0143 63.5828 18.8173C62.6631 18.1587 61.754 17.6224 60.7494 17.4024C57.0473 16.6178 54.2909 20.3076 54.585 23.669C55.141 30.0251 63.7087 35.7419 65.0533 35.6242C66.3978 35.5066 73.848 28.45 73.2865 22.0328C72.9924 18.6714 69.515 15.527 66.1276 16.9318Z",
    fill: "white"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip3_11304_9690)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M86.9238 125.821C100.08 124.206 109.435 112.231 107.82 99.0749C106.205 85.9189 94.2301 76.5633 81.074 78.1787C67.918 79.794 58.5624 91.7686 60.1778 104.925C61.7932 118.081 73.7677 127.436 86.9238 125.821Z",
    fill: "#C9203D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.2119 92.2353C85.0876 92.7442 84.0813 93.6095 83.239 94.603C82.1084 93.8518 80.9957 93.2467 79.7817 93.0249C75.309 92.2389 72.1579 96.7795 72.6513 100.798C73.5844 108.398 84.0988 114.895 85.7063 114.698C87.3139 114.5 95.9531 105.725 95.011 98.053C94.5176 94.0341 90.2154 90.4086 86.2119 92.2353Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_11304_9690"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 104,
    height: 104,
    fill: "white",
    transform: "translate(93 20)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_11304_9690"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white",
    transform: "translate(211.445 78.6543) rotate(4)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip2_11304_9690"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white",
    transform: "translate(42.333 6.81641) rotate(-5)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip3_11304_9690"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    fill: "white",
    transform: "translate(57.2529 81.1035) rotate(-7)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIntensiveMinutes);
export default __webpack_public_path__ + "static/media/intensive-minutes.83befcb8f594ae43bd23d4601cacff9f.svg";
export { ForwardRef as ReactComponent };